import React from 'react';
import './Project.css';
function Project({ img, name, detail, git, web, tags }) {
  return (
    <div className="col-12 col-sm-6 col-lg-4 my-4" id="project">
      <div className="card">
        <img src={img} className="card-img-top" alt={name} />
        <div className="card-body mb-3">
          <h5 className="card-title mt-3">{name}</h5>
          <div className="project__border mb-3"></div>
          <p className="card-text">{detail}</p>
          <div className="d-flex mb-3 flex-wrap">
            {tags?.map((tag) => (
              <p className="mr-2 project__label">{tag}</p>
            ))}
          </div>
          {git && (
            <a href={git} className="btn btn-primary mr-2">
              <i className="fab fa-github"></i>
            </a>
          )}
          {web && (
            <a href={web} className="btn btn-primary">
              <i className="fas fa-external-link-alt"></i>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default Project;
